import React, { useEffect, useCallback, useState } from "react";
import { Grid, Row, Col, Space, Spin, message, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import CountdownTimer from "../components/CountdownTimer";
import styles from "./StakingHome.module.css";
import _ from "lodash";
import * as Service from "../core/Service";
import { ActionCreators } from "../redux/actions";
import { ethers } from "ethers";

const { useBreakpoint } = Grid;

const StakingConfirm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const breakpoint = useBreakpoint();

  const location = useLocation();
  const selectedNft = location.state?.selectedNft;
  if (!selectedNft) {
    history.push("/storing");
  }

  const [loading, setLoading] = useState(true);
  const [expCount, setExpCount] = useState(0);
  const [ticketCount, setTicketCount] = useState(0);
  const [nextCheckInTime, setNextCheckInTime] = useState(0);

  const [stakeOptions, setStakeOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});

  const { IS_TESTNET } = useSelector((state) => state.app.config);

  const isPollingApproveNftStatus = useSelector(
    (state) => state.app.isPollingApproveNftStatus
  );

  const wallet_address = localStorage.getItem("wallet_address");

  const getDailyCheckInData = useCallback(async () => {
    setLoading(true);

    try {
      const resp = await Service.callServer("get", "/api/stake_record", {
        wallet_address,
      });
      const data = resp.data;

      if (!resp || resp?.msg) {
        message.error(resp?.msg || "Error");
        setLoading(false);
        return;
      }

      setExpCount(data?.exp || 0);
      setTicketCount(data?.total_tickets || 0);
      setNextCheckInTime(
        data?.next_check_in_time > 0 ? data?.next_check_in_time : 0
      );
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [wallet_address]);

  const getStakeOption = useCallback(async () => {
    setLoading(true);

    try {
      const resp = await Service.callServer("get", "/api/stake_option");
      const data = resp.data;

      if (!resp || resp?.msg) {
        message.error(resp?.msg || "Error");
        setLoading(false);
        return;
      }

      setStakeOptions(data || []);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, []);

  const postStaking = useCallback(async () => {
    setLoading(true);
    dispatch(ActionCreators.setIsPollingApproveNftStatus(true));

    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      // Check is approved or not
      const isApprovedResp = await Service.callServer(
        "get",
        "/polygon/nft/getApproved",
        { token_id: _.toNumber(selectedNft?.tokenId) }
      );

      if (!isApprovedResp || isApprovedResp?.msg) {
        message.error(isApprovedResp?.msg || "Error");
        return;
      }

      const isApproved = isApprovedResp?.data;

      if (isApproved === false) {
        // Get approval tx parmas
        const approvalResp = await Service.callServer(
          "post",
          "/polygon/nft/approve",
          {
            wallet_address,
            token_id: _.toNumber(selectedNft?.tokenId),
          }
        );
        if (!approvalResp || approvalResp?.msg) {
          message.error(approvalResp?.msg || "Error");
          return;
        }

        const approvalSignParams = {
          from: wallet_address,
          to: approvalResp.data.to,
          data: approvalResp.data.data,
        };

        // Send approval transaction
        const approvalRawTransaction = await signer.sendTransaction(
          approvalSignParams
        );

        // Wait until approval finished
        const transactionResult = await provider.waitForTransaction(
          approvalRawTransaction.hash
        );

        if (!transactionResult) {
          message.error("NFT transaction approval is failed.");
          setLoading(false);
          dispatch(ActionCreators.setIsPollingApproveNftStatus(false));
          return;
        }
      }

      // Get stake tx params
      const stakeResp = await Service.callServer(
        "post",
        "/polygon/stake/transaction/create",
        {
          wallet_address,
          token_id: selectedNft?.tokenId,
          period: selectedOption?.period,
        }
      );
      if (!stakeResp || stakeResp?.msg) {
        message.error(stakeResp?.msg || "Error");
        return;
      }

      const stakeSignParams = {
        from: wallet_address,
        to: stakeResp.data.to,
        data: stakeResp.data.data,
      };

      // Send stake transaction
      const stakeRawTransaction = await signer.sendTransaction(stakeSignParams);

      const addStakeRecordResp = await Service.callServer(
        "post",
        "/api/stake_record/create",
        {
          wallet_address,
          token_id: selectedNft?.tokenId,
          period: selectedOption?.period,
          stake_option_id: selectedOption?.stake_option_id,
        }
      );

      setLoading(false);
      dispatch(ActionCreators.setIsPollingApproveNftStatus(false));
      dispatch(ActionCreators.setIsPollingStakeStatus(true));
      history.push("/storing");
    } catch (err) {
      console.log(err);
      message.error("Transaction error.");
      setLoading(false);
      dispatch(ActionCreators.setIsPollingApproveNftStatus(false));
    }

    setLoading(false);
    dispatch(ActionCreators.setIsPollingApproveNftStatus(false));
  }, [wallet_address, selectedNft, selectedOption, IS_TESTNET, dispatch]);

  useEffect(() => {
    if (_.isUndefined(IS_TESTNET)) {
      return;
    }
    getDailyCheckInData();
    getStakeOption();
  }, [IS_TESTNET, getDailyCheckInData, getStakeOption]);

  return (
    <Spin spinning={loading}>
      <AppLayout>
        <div className="boxContainer">
          <div className={styles.stakingHomeContainer}>
            <Row gutter={[12]} justify="center">
              <Col>
                <img
                  src="/images/landing/star.png"
                  style={{ width: 32, height: 32 }}
                  alt=""
                />
              </Col>
              <Col className={styles.ft_32_600_title}>Sweat & Earn</Col>
              <Col>
                <img
                  src="/images/landing/star.png"
                  style={{ width: 32, height: 32 }}
                  alt=""
                />
              </Col>
            </Row>

            <Row
              justify="center"
              className={styles.ft_44_900}
              style={{ marginTop: 16 }}
            >
              Together: we build the future of wellness
            </Row>

            <div
              className={styles.nftGradientBorder}
              style={{
                textAlign: "center",
                marginTop: breakpoint?.md ? 40 : 24,
                marginBottom: 20,
              }}
            >
              <img
                src={
                  selectedNft?.image?.originalUrl ||
                  "/images/staking/sample_nft.png"
                }
                alt=""
                style={{
                  width: breakpoint?.md ? 320 : 264,
                  height: breakpoint?.md ? 320 : 264,
                  borderRadius: 24,
                }}
              />
            </div>

            <Space direction="vertical" size={20} style={{ display: "flex" }}>
              {nextCheckInTime > 0 && (
                <Row justify="center" className={styles.ft_24_500}>
                  {`Daily check-in reset time: `}
                  <CountdownTimer
                    timestamp={nextCheckInTime}
                    reloadFunc={() => getDailyCheckInData()}
                  />
                </Row>
              )}

              {_.isEmpty(selectedOption) && (
                <Row justify="center" gutter={[20]}>
                  <Col className={styles.ft_32_600}>Exp = {expCount}</Col>
                  <Col className={styles.ft_32_600}>Ticket: {ticketCount}</Col>
                </Row>
              )}

              {!_.isEmpty(selectedOption) && (
                <div style={{ textAlign: "center" }}>
                  <Row justify="center" className={styles.ft_32_600}>
                    Confirm to store your
                  </Row>
                  <Row justify="center" className={styles.ft_32_600}>
                    Genesis NFT?
                  </Row>
                </div>
              )}

              {_.isEmpty(selectedOption) && (
                <>
                  <Row justify="center" gutter={[20, 20]}>
                    {_.map(stakeOptions, (obj) => {
                      return (
                        <Col
                          key={obj?.stake_option_id}
                          span={breakpoint?.md ? "" : 24}
                        >
                          <div
                            className={styles.button}
                            onClick={() => {
                              setSelectedOption(obj);
                            }}
                          >
                            <div className={styles.buttonText}>
                              {`${obj?.period} Days = ${obj?.ticket} ticket`}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                  <Row justify="center">
                    <div
                      className={styles.outlineBtn}
                      style={{ marginBottom: 20 }}
                      onClick={() => {
                        history.push("/storing");
                      }}
                    >
                      <div className={styles.outlineBtnText}>Cancel</div>
                    </div>
                  </Row>
                </>
              )}

              {!_.isEmpty(selectedOption) && (
                <Row
                  justify="center"
                  gutter={[20, 20]}
                  style={{ marginBottom: 20 }}
                >
                  <Col span={breakpoint?.md ? "" : 24}>
                    <div className={styles.button} onClick={postStaking}>
                      <div className={styles.buttonText}>Confirm</div>
                    </div>
                  </Col>

                  <Col span={breakpoint?.md ? "" : 24}>
                    <div
                      className={styles.outlineBtn}
                      onClick={() => {
                        setSelectedOption({});
                      }}
                    >
                      <div className={styles.outlineBtnText}>Cancel</div>
                    </div>
                  </Col>
                </Row>
              )}
            </Space>
          </div>

          <Modal
            open={isPollingApproveNftStatus}
            closeIcon={<></>}
            maskClosable={false}
            footer={null}
          >
            <div
              style={{
                display: "grid",
                placeContent: "center",
                textAlign: "center",
              }}
            >
              <div
                className={`${styles.buttonText}`}
                style={{ lineHeight: "28px" }}
              >
                The storing is processing.
              </div>
              <div
                className={`${styles.buttonText}`}
                style={{ lineHeight: "28px" }}
              >
                {`Please don't close or redirect to other page.`}
              </div>
              <Spin spinning style={{ marginTop: 20 }} />
            </div>
          </Modal>
        </div>
      </AppLayout>
    </Spin>
  );
};

export default StakingConfirm;
